import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  textArea: {
    width: "100%",
    minHeight: "100px !important",
    borderRadius: 4,
    border: "1px solid #dadce0",
    paddingLeft: 10,
  },
  answer: {
    width: "100%",
  },
  field: {
    width: "99%",
    maxWidth: "700px",
  },
  helperTextRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    width: "99%",
  },
  helperTextContainer: {
    maxWidth: "75%",
  },
});

export default useStyles;
